// Click to call é uma funcionalidade que a org liga pela configuração em
// Integrações (/settings/click-to-call). A navegação (sidebar e drawer mobile)
// lê o mesmo cache que a tela escreve para decidir se mostra as telas
// operacionais — daí este gate viver aqui, fora das duas pontas.
//
// A CHAVE não mora mais aqui: o toggle é /v1/sip/click-to-call e foi para
// src/api/sip.ts, com os hooks das telas em src/hooks/use-sip.ts. `sipKeys` é a
// fonte única da string ["click-to-call"] — este arquivo importa de lá para que
// a navegação e as telas continuem lendo A MESMA entrada de cache.
//
// O que fica aqui é o que é da NAVEGAÇÃO e não de uma tela de telefonia: o
// `retry: false` e o colapso do resultado num booleano.
import { useQuery } from "@tanstack/react-query";
import { getClickToCall } from "@/api/sip";
import { sipKeys } from "@/hooks/use-sip";

// `enabled` desliga a query para quem não pode ver as telas do grupo (vendedor):
// sem isso o menu dispararia um GET que o backend recusa. Enquanto carrega — ou
// se o GET falhar — o resultado é `false`: o grupo só aparece com confirmação.
export function useClickToCallEnabled(enabled = true): boolean {
  const q = useQuery({
    queryKey: sipKeys.clickToCall,
    queryFn: getClickToCall,
    enabled,
    retry: false,
  });
  return q.data?.clickToCallEnabled ?? false;
}
